<template>
    <div>
        <div :class="num>0.25?'blue':'red'">
            <div :class="num>=0.5?'two':'two lightBlue'">
                <div :class="num>=0.75?'three':'three lightBlue'">
                    <div :class="num>=1?'four':'four lightBlue'"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "signal",
        props:{
          num:Number,
        },
    }
</script>

<style scoped lang="less">
.relative{
    position: relative;
    height: 5px;
    width: 3px;
}
.absolute{
    position: absolute;
    left: 6px;
    bottom: 0;
    background: #286EFF;
}
.blue{
   .relative;
    background: #286EFF;
}
.red{
    .relative;
    background: #E90422;
}
.two{
    .absolute;
    height: 10px;
    width: 3px;
}
.three{
    .absolute;
    height: 15px;
    width: 3px;
}
.four{
    .absolute;
    height: 20px;
    width: 3px;
}
.lightBlue{
    background: #E9F0FF;
}
</style>
